// import './../App.css';
import { useState } from 'react';
import { AccountSettings } from '@aws-amplify/ui-react';
//import '@aws-amplify/ui-react/styles.css';

import { Alert, Box, Paper, Stack} from '@mui/material';

export function ChangePassword() {
    const [alertArea, setAlertArea] = useState(null);
    const handleSuccess = () => {
        setAlertArea((
            <Box sx={{paddingBottom: "10px"}}>
            <Alert severity='success'>Success!</Alert>
            </Box>
        ))
    }

    const handleError = (error) => {
        setAlertArea((
            <Box sx={{paddingBottom: "10px"}}>
            <Alert severity='error' sx={{padding: "10px"}}>{error.message}</Alert>
            </Box>
        ))
    }

    const components = {
        ErrorMessage: ({ children }) => ("")
      };

    return (
        <Box sx={{p: {xs: 0, s: 0, md: 10}, width: "100%"}} >
            <Box sx={{mt: {xs: 15}, minWidth: '400px', maxWidth: '30%', mx: 'auto'}}>        
                <h2>Change Password</h2>
                <Box>
                        {alertArea}
                        <AccountSettings.ChangePassword components={components} onSuccess={handleSuccess} onError={handleError} />          
                </Box>
            </Box>
        </Box>
    );
}

export default ChangePassword;